import script from "./NativeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__